import React from 'react';
import { useCourseContext } from '../../CourseContext';
import { PipelineCard, PipelineCardStatus } from '../../shared/PipelineCard';

interface CoursePipelineStage {
  id: string;
  name: string;
}

const COURSE_STAGES: CoursePipelineStage[] = [
  { id: 'course_setup', name: 'Course Setup' },
  { id: 'course_syllabus', name: 'Syllabus Generation' },
  { id: 'course_syllabus_review', name: 'Syllabus Review' },
  { id: 'course_lessons', name: 'Lessons Dashboard' },
  { id: 'course_artwork', name: 'Course Artwork' },
  { id: 'course_publish', name: 'Publish' },
];

export function CoursePipelineSidebar() {
  const { selectedStageId, setSelectedStageId, run } = useCourseContext();
  const runStages = run?.stages || [];

  return (
    <>
      {COURSE_STAGES.map((stage, index) => {
        const stageRecord = runStages.find((s) => s.stage_id === stage.id);
        const status: PipelineCardStatus =
          stageRecord?.status === 'succeeded' || stageRecord?.status === 'failed' || stageRecord?.status === 'running'
            ? stageRecord.status
            : 'pending';
        return (
          <PipelineCard
            key={stage.id}
            stageId={stage.id}
            number={String(index + 1)}
            name={stage.name}
            status={status}
            selected={selectedStageId === stage.id}
            cost={stageRecord?.total_cost_usd ? Number(stageRecord.total_cost_usd) : undefined}
            runCount={((stageRecord as { runs?: unknown[] } | undefined)?.runs?.length) || 0}
            onClick={() => setSelectedStageId(stage.id)}
          />
        );
      })}
    </>
  );
}
